import { IconProps } from "../../utils/global-types/global-types";

const TimeIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 12 12"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6 .5a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11m0 2.063a.687.687 0 0 0-.687.687V6c0 .182.072.357.2.486L7.459 8.43l.053.048a.687.687 0 0 0 .967-.967l-.048-.053-1.742-1.743V3.25A.687.687 0 0 0 6 2.563"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export default TimeIcon;
